// src/apiConfig.js
export const API_BASE = "https://egt2axq41g.execute-api.us-east-1.amazonaws.com/dev";
